import {useEffect} from 'react'
import {useCustomerType} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {buildOptimizelyAttributes, normalizeCustomerGroups} from '../utils/optimizely-attributes'
import {getVisitorId} from '../utils/optimizely-visitor-id'
import {setFxTrackingContext} from '../utils/optimizely-fx-events'
import {useOptimizelyFxConfig} from './use-optimizely-fx-config'

/*
 * Keeps the FX conversion-tracking context (enabled, sdkKey, visitor id,
 * attributes) in sync with the session. The identity is the stable visitor
 * UUID — the same id /optimizely-page buckets with via x-visitor-id — so
 * impressions and conversions attribute to one Optimizely visitor. Values are
 * consumed only inside the effect, so SSR/hydration output is untouched.
 */
export function useOptimizelyFxTracking() {
    const {enabled, sdkKey, brandSlug, localeId} = useOptimizelyFxConfig()
    const {isRegistered} = useCustomerType()
    const {data: customer} = useCurrentCustomer()
    const customerGroupsCsv = normalizeCustomerGroups(customer?.c_customerGroups).join(',')

    useEffect(() => {
        setFxTrackingContext({
            enabled,
            sdkKey,
            userId: getVisitorId() || 'anonymous',
            attributes: buildOptimizelyAttributes({
                brandSlug,
                localeId,
                isLoggedIn: !!isRegistered,
                customerGroups: customerGroupsCsv ? customerGroupsCsv.split(',') : []
            })
        })
    }, [enabled, sdkKey, brandSlug, localeId, isRegistered, customerGroupsCsv])
}
